/**
 * Saved items (tasks/wishlist-spec.md). One script for:
 *
 *   1. Hearts       every .wally-save button (cards, product page) saves or removes the product
 *   2. Header       .wally-saved-count shows how many are saved
 *   3. Saved page   #wally-saved renders the list from /products/{handle}.js (live price + stock),
 *                   or a read-only shared list when the URL carries ?share=handle,handle
 *   4. Sync         people we already know (arrived from a Wally email: wid; or logged in:
 *                   signed customer id) sync to wally-email POST /forms/saved, so the list
 *                   follows them across devices and saved pieces join the Price Drop email.
 *                   Everyone else's list stays on this device.
 *   5. Signals      an anonymous 'save' event to the tracking worker (same as wally-grid.js)
 *                   and GA4 add_to_wishlist.
 *
 * Price drops are never mentioned on the site (Staci, 23/10/2026).
 * Loaded on every page by snippets/wally-tracking.liquid.
 */
(function () {
  'use strict';

  var API = 'https://go.wally.co.nz/forms/saved';
  var KEY = { list: 'wally_saved', removed: 'wally_saved_removed', toast: 'wally_saved_toast', synced: 'wally_saved_synced' };
  var MAX = 100;
  var SHARE_MAX = 30;
  var SYNC_EVERY_MS = 10 * 60 * 1000;
  var cfg = window.__wallySaved || {};
  var params = new URLSearchParams(location.search);

  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* private mode */ } }
  function sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { sessionStorage.setItem(k, v); } catch (e) { /* private mode */ } }
  function read(k) { try { return JSON.parse(get(k) || '[]') || []; } catch (e) { return []; } }

  var list = read(KEY.list).filter(function (x) { return x && /^\d+$/.test(String(x.product_id)); });
  var removed = read(KEY.removed);
  function store() { set(KEY.list, JSON.stringify(list)); set(KEY.removed, JSON.stringify(removed)); }
  function has(id) { return list.some(function (x) { return x.product_id === id; }); }

  // ---- 4. sync -------------------------------------------------------------------------
  // wally-email.js keeps the email link's _wid in localStorage; read the URL too in case it hasn't run yet.
  var wid = params.get('_wid') || get('wally_wid');
  var known = !!(wid || cfg.customer);
  var syncing = null;
  var syncAgain = false;

  function sync() {
    if (!known || sget(KEY.synced) === 'no') return;
    if (syncing) { syncAgain = true; return; }
    var sent = removed.slice();
    var body = { items: list, removed: sent };
    if (wid) body.wid = wid; else body.customer = cfg.customer;
    syncing = fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) {
        if (r.status === 401) { sset(KEY.synced, 'no'); return null; } // not someone we know after all: stay on the device
        return r.ok ? r.json() : null;
      })
      .then(function (j) {
        if (!j || !j.ok || !Array.isArray(j.items)) return;
        // The server's list is the merged truth. Keep anything saved or removed here while the
        // request was out; the next sync sends it.
        removed = removed.filter(function (x) { return sent.indexOf(x) === -1; });
        var gone = function (y) { return removed.some(function (x) { return x.product_id === y.product_id; }); };
        var later = list.filter(function (x) { return !j.items.some(function (y) { return y.product_id === x.product_id; }) && !body.items.some(function (y) { return y.product_id === x.product_id; }); });
        list = later.concat(j.items.filter(function (y) { return !gone(y); })).slice(0, MAX);
        store();
        sset(KEY.synced, String(Date.now()));
        refresh();
        if (page) renderPage();
      })
      .catch(function () { /* try again on the next page */ })
      .then(function () { syncing = null; if (syncAgain) { syncAgain = false; sync(); } });
  }

  // ---- 5. signals ----------------------------------------------------------------------
  function signal(btn, id) {
    var ep = window.__wEp;
    if (ep) {
      var sid = sget('wally_sid');
      if (!sid) { sid = window.crypto && crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2); sset('wally_sid', sid); }
      var grid = btn && btn.closest('[data-collection]');
      var payload = JSON.stringify({
        events: [{ type: 'save', product_id: 'gid://shopify/Product/' + id, collection: (grid && grid.getAttribute('data-collection')) || params.get('ref') || 'direct', timestamp: Math.floor(Date.now() / 1000) }],
        session_id: sid,
        page_url: location.pathname
      });
      if (navigator.sendBeacon) navigator.sendBeacon(ep, payload);
    }
    if (typeof window.gtag === 'function' && btn) {
      var price = Number(btn.getAttribute('data-price')) || undefined;
      window.gtag('event', 'add_to_wishlist', { currency: 'NZD', value: price, items: [{ item_id: id, item_name: btn.getAttribute('data-title') || '', price: price }] });
    }
  }

  // ---- 1 + 2. hearts and header --------------------------------------------------------
  function refresh() {
    var buttons = document.querySelectorAll('.wally-save');
    for (var i = 0; i < buttons.length; i++) {
      var on = has(buttons[i].getAttribute('data-product-id'));
      if (buttons[i].getAttribute('aria-pressed') !== String(on)) buttons[i].setAttribute('aria-pressed', String(on));
    }
    // Only write when the number changes. Setting textContent always swaps the text node, which
    // fires the body observer below, which calls refresh again: an every-frame loop that kept the
    // page from ever going idle, so Horizon never tracked new grid cards (page 2 repeated on
    // scroll, filters and sort stopped re-rendering). 24/10/2026.
    var text = list.length > 99 ? '99+' : String(list.length);
    var counts = document.querySelectorAll('.wally-saved-count');
    for (var j = 0; j < counts.length; j++) {
      if (counts[j].textContent !== text) counts[j].textContent = text;
      if (counts[j].hidden !== !list.length) counts[j].hidden = !list.length;
    }
  }

  function add(item) {
    removed = removed.filter(function (x) { return x.product_id !== item.product_id; });
    list = [item].concat(list.filter(function (x) { return x.product_id !== item.product_id; })).slice(0, MAX);
  }

  function remove(id) {
    list = list.filter(function (x) { return x.product_id !== id; });
    removed = removed.filter(function (x) { return x.product_id !== id; }).concat([{ product_id: id, at: new Date().toISOString() }]).slice(-MAX);
  }

  var syncTimer;
  function changed() {
    store();
    refresh();
    clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, 800);
  }

  function productForm(id) {
    var forms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
    for (var i = 0; i < forms.length; i++) {
      var pid = forms[i].querySelector('[name="product-id"]');
      if (pid && pid.value === id) return forms[i];
    }
    return null;
  }

  function toggle(btn) {
    var id = btn.getAttribute('data-product-id');
    if (!/^\d+$/.test(id || '')) return;
    if (has(id)) {
      remove(id);
    } else {
      // On the product page take the size from the product form's own variant input at the
      // moment of saving (the theme swaps sizes without re-rendering the heart, which sits on
      // the name row outside the form).
      // Only the product page's name-row heart reads the form: a card's quick-add form holds a
      // default size nobody chose.
      var form = btn.closest('form') || (btn.classList.contains('wally-save--title') && productForm(id));
      var size = form && form.querySelector('[name="id"]');
      add({ product_id: id, handle: btn.getAttribute('data-handle'), variant_id: (size && size.value) || btn.getAttribute('data-variant-id') || null, at: new Date().toISOString() });
      signal(btn, id);
      if (!get(KEY.toast)) { set(KEY.toast, '1'); toast(); }
    }
    changed();
    if (page && !shared && !shareCode) renderPage();
  }

  function toast() {
    var t = document.createElement('div');
    t.className = 'wally-saved-toast';
    t.setAttribute('role', 'status');
    t.innerHTML = 'Saved. Find it any time under the heart up top. <a href="' + esc(cfg.page || '/pages/saved') + '">View</a>';
    document.body.appendChild(t);
    void t.offsetWidth; // lay it out closed first so the fade in runs
    t.classList.add('is-open');
    setTimeout(function () { t.classList.remove('is-open'); setTimeout(function () { t.remove(); }, 400); }, 4000);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target instanceof Element && e.target.closest('.wally-save');
    if (!btn) return;
    e.preventDefault();
    toggle(btn);
  });

  // Cards and the product page's buy buttons are re-rendered by the theme (filters, infinite
  // scroll, variant changes, recommendations), so put the hearts back in step when they appear.
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; refresh(); });
  }).observe(document.body, { childList: true, subtree: true });

  // Another tab saved something.
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY.list) return;
    list = read(KEY.list);
    refresh();
  });

  // ---- 3. the Saved page ---------------------------------------------------------------
  var page = document.getElementById('wally-saved');
  // ?share=handle:variant,handle (the size is optional): a list someone sent, shown read-only.
  var shared = page ? (params.get('share') || '').split(',').map(function (x) {
    var m = /^([a-z0-9-]+)(?::(\d+))?$/.exec(x);
    return m && { handle: m[1], variant_id: m[2] || null };
  }).filter(Boolean).slice(0, SHARE_MAX) : [];
  if (page && !shared.length) shared = null;
  // ?l=<code>: a short share link, its list kept by wally-email (POST/GET /forms/share).
  var SHARE_API = 'https://go.wally.co.nz/forms/share';
  // Share links are go.wally.co.nz/h/<code>: wally-email gives link-preview apps (iMessage,
  // WhatsApp, Messenger) the hint title and image for that exact link, and sends people on to
  // /pages/hint?l=<code> (same template as Saved). Long ?share= links still open /pages/hint.
  var HINT_PAGE = '/pages/hint';
  var HINT_LINK = 'https://go.wally.co.nz/h/';
  // Staci's words (23/10/2026). Gmail takes the subject from the title or the linked page's title;
  // Apple Mail never sets a subject from a web share (tested: link-only came through blank too),
  // so "Or send it by email" opens the person's mail app with subject and message filled in.
  var SHARE_TITLE = 'Dropping you a hint from Wally \uD83D\uDC40'; // first person: it comes from them
  var SHARE_TEXT = 'Not to be obvious, but here\u2019s what I\u2019ve got my eye on at Wally...\n\nClick the link to view my saved items \uD83D\uDE4F';
  function mailtoUrl(url) {
    return 'mailto:?subject=' + encodeURIComponent(SHARE_TITLE) + '&body=' + encodeURIComponent(SHARE_TEXT.replace(/\n/g, '\r\n') + '\r\n\r\n' + url);
  }
  var shareCode = page && !shared && /^[0-9A-Za-z]{7,12}$/.test(params.get('l') || '') ? params.get('l') : null;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var money = new Intl.NumberFormat('en-NZ', { style: 'currency', currency: 'NZD' });
  function price(cents) { return money.format((cents || 0) / 100); }
  var HEART = '<svg class="wally-save__icon" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>';

  var cache = {};
  function product(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return undefined; }); // offline: keep it, try again later
    }
    return cache[handle];
  }

  // A line under the price from the product's real stock: the size they saved, or when only one
  // or two sizes are left. Nothing for one-size products.
  function sizeNote(p, variantId, whose) {
    var vs = p.variants || [];
    // Wally products are one colour each, with Colour first and Size second: find Size by name.
    var at = (p.options || []).map(function (o) { return String(o.name || o).toLowerCase(); }).indexOf('size');
    if (!p.available || vs.length < 2 || at < 0) return '';
    var size = function (v) { return v['option' + (at + 1)]; };
    var mine = variantId && vs.filter(function (v) { return String(v.id) === String(variantId); })[0];
    if (mine) {
      return mine.available
        ? '<span class="wally-saved__note">' + whose + ' size: ' + esc(size(mine)) + '</span>'
        : '<span class="wally-saved__note wally-saved__note--out">' + whose + ' size (' + esc(size(mine)) + ') has sold out</span>';
    }
    var left = vs.filter(function (v) { return v.available; }).map(size);
    if (vs.length > 2 && left.length <= 2) return '<span class="wally-saved__note">Only ' + esc(left.join(' and ')) + ' left</span>';
    return '';
  }

  // A shared list is for buying (usually a present), so each piece gets Add to cart in the size
  // they saved (or its only size), or Choose size when we don't know it.
  function buyButton(p, variantId) {
    if (!p.available) return '';
    var vs = p.variants || [];
    var v = (variantId && vs.filter(function (x) { return String(x.id) === String(variantId) && x.available; })[0]) ||
      (vs.length === 1 && vs[0].available ? vs[0] : null);
    return v
      ? '<button type="button" class="wally-saved__buy wally-saved__add" data-variant="' + v.id + '" data-handle="' + esc(p.handle) + '">Add to cart</button>'
      : '<a class="wally-saved__buy wally-saved__choose" href="' + esc(p.url) + '">Choose size</a>';
  }

  // opts: { remove: true } on your own list, { save: true } for New In suggestions,
  // { buy: variantId-or-null } on a shared list, note: html
  function card(p, opts) {
    var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
    var sale = p.compare_at_price && p.compare_at_price > p.price;
    return '<li class="wally-saved__item">' +
      '<a class="wally-saved__media" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
      (opts.remove ? '<button type="button" class="wally-saved__remove" data-remove="' + p.id + '" aria-label="Remove ' + esc(p.title) + '">' +
        '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.5"/></svg></button>' : '') +
      (opts.save ? '<button type="button" class="wally-save wally-save--card" data-product-id="' + p.id + '" data-handle="' + esc(p.handle) + '" data-title="' + esc(p.title) +
        '" data-price="' + (p.price / 100) + '" aria-pressed="' + has(String(p.id)) + '" aria-label="Save ' + esc(p.title) + '">' + HEART + '</button>' : '') +
      '<a class="wally-saved__info" href="' + esc(p.url) + '">' +
        '<span class="wally-saved__vendor">' + esc(p.vendor) + '</span>' +
        '<span class="wally-saved__name">' + esc(p.title) + '</span>' +
        (p.available
          ? '<span class="wally-saved__price">' + (sale ? '<s>' + price(p.compare_at_price) + '</s> <span class="wally-saved__now">' + price(p.price) + '</span>' : price(p.price)) + '</span>'
          : '<span class="wally-saved__price wally-saved__soldout">Sold out</span>') +
        (opts.note || '') +
      '</a>' + ('buy' in opts ? buyButton(p, opts.buy) : '') + '</li>';
  }

  // Shared from a preview theme, the link has to open that preview too, or it lands on the live theme.
  function previewParam() {
    var theme = window.Shopify && Shopify.theme;
    return theme && theme.role !== 'main' ? '&preview_theme_id=' + theme.id : '';
  }
  function previewQuery() {
    var theme = window.Shopify && Shopify.theme;
    return theme && theme.role !== 'main' ? '?p=' + theme.id : '';
  }

  function shareItems() {
    return list.filter(function (x) { return x.handle; }).slice(0, SHARE_MAX).map(function (x) { return { handle: x.handle, variant_id: x.variant_id || null }; });
  }

  // The short link is fetched as soon as the list shows, so it is ready the moment someone taps
  // Drop a hint (Safari only opens the share sheet straight from the tap, not after a wait).
  var short = { key: null, url: null };
  function prepareShare() {
    var items = shareItems();
    var key = JSON.stringify(items);
    if (!items.length || short.key === key) return;
    short = { key: key, url: null };
    fetch(SHARE_API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j.code || short.key !== key) return;
        short.url = HINT_LINK + j.code + previewQuery();
        // iPhones read a link's address as it is tapped, so it has to be complete before the tap.
        var email = page && page.querySelector('.wally-saved__email');
        if (email) email.setAttribute('href', mailtoUrl(short.url));
      })
      .catch(function () { /* the long link still works */ });
  }

  function shareUrl() {
    if (short.url && short.key === JSON.stringify(shareItems())) return short.url;
    var items = shareItems().map(function (x) { return x.handle + (x.variant_id ? ':' + x.variant_id : ''); });
    return location.origin + HINT_PAGE + '?share=' + items.join(',') + previewParam();
  }

  function setTitle(text) {
    var title = page.querySelector('.wally-saved__title');
    if (title) title.textContent = text;
  }

  // Empty list: an invitation, then the newest piece from each of four brands in New In, with
  // hearts, so the page is never a dead end.
  var fresh;
  function renderEmpty() {
    body.innerHTML = '<div class="wally-saved__none">' +
        '<span class="wally-saved__none-icon" aria-hidden="true">' + HEART + '</span>' +
        '<h2 class="wally-saved__none-title">Nothing saved yet</h2>' +
        '<p>Tap the heart on anything that catches your eye and it’ll wait for you here.</p>' +
        '<a class="wally-saved__button wally-saved__button--solid" href="/collections/new-in">Shop new in</a>' +
      '</div><div class="wally-saved__fresh"></div>';
    fresh = fresh || fetch('/collections/new-in/products.json?limit=80')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        var brands = {};
        return (j.products || []).filter(function (p) {
          if (brands[p.vendor] || !p.variants.some(function (v) { return v.available; })) return false;
          return (brands[p.vendor] = true);
        }).slice(0, 4).map(function (p) {
          var v = p.variants.filter(function (x) { return x.available; })[0];
          var cents = function (x) { return Math.round(Number(x || 0) * 100); };
          return { id: p.id, handle: p.handle, title: p.title, vendor: p.vendor, url: '/products/' + p.handle, available: true,
            featured_image: p.images[0] && p.images[0].src, price: cents(v.price), compare_at_price: cents(v.compare_at_price) };
        });
      })
      .catch(function () { return []; });
    fresh.then(function (ps) {
      var box = body.querySelector('.wally-saved__fresh');
      if (!box || !ps.length) return;
      box.innerHTML = '<h2 class="wally-saved__fresh-title">Just landed</h2><ul class="wally-saved__grid">' + ps.map(function (p) { return card(p, { save: true }); }).join('') + '</ul>';
    });
  }

  var body;
  function renderPage() {
    body = body || page.querySelector('.wally-saved__body');
    if (shared) return renderShared();
    if (shareCode) return loadShared();
    if (!list.length) return renderEmpty();
    var items = list.slice();
    Promise.all(items.map(function (x) { return product(x.handle); })).then(function (ps) {
      var gone = [];
      var html = '';
      var n = 0;
      ps.forEach(function (p, i) {
        if (p === null) gone.push(items[i].product_id); // archived, draft or renamed: drop it quietly
        else if (p) { n++; html += card(p, { remove: true, note: sizeNote(p, items[i].variant_id, 'Your') }); }
      });
      if (gone.length) { gone.forEach(remove); changed(); }
      if (!list.length) return renderPage();
      body.innerHTML = '<p class="wally-saved__sub">' + (n === 1 ? '1 piece you’ve got your eye on. It’ll wait here for you.' : n + ' pieces you’ve got your eye on. They’ll wait here for you.') + '</p>' +
        '<ul class="wally-saved__grid">' + html + '</ul>' +
        '<div class="wally-saved__actions">' +
          '<button type="button" class="wally-saved__button wally-saved__button--solid wally-saved__share">Drop a hint</button>' +
          '<p class="wally-saved__msg" role="status"></p>' +
          '<a class="wally-saved__email" href="' + esc(mailtoUrl(shareUrl())) + '">Or send it by email</a>' +
          '<p class="wally-saved__visit">Rather try them on? Come and see us at 53 Hurstmere Road, Takapuna.</p>' +
          (cfg.customer || window.__wallyEmail && window.__wallyEmail.known ? '' :
            '<p class="wally-saved__login"><a href="' + esc(cfg.loginUrl || '/account/login') + '">Log in</a> to keep your list on any device</p>') +
        '</div>';
      prepareShare();
    });
  }

  function loadShared() {
    setTitle('Someone\u2019s dropped a hint');
    fetch(SHARE_API + '/' + shareCode)
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (j) {
        shared = j && j.ok && Array.isArray(j.items) ? j.items.slice(0, SHARE_MAX) : [];
        renderShared();
      });
  }

  function renderShared() {
    setTitle('Someone’s dropped a hint');
    Promise.all(shared.map(function (x) { return product(x.handle); })).then(function (ps) {
      var found = [];
      ps.forEach(function (p, i) { if (p) found.push({ p: p, variant_id: shared[i].variant_id }); });
      body.innerHTML = '<p class="wally-saved__sub">Here’s what they’ve got their eye on.</p>' +
        (found.length ? '<ul class="wally-saved__grid">' + found.map(function (x) { return card(x.p, { note: sizeNote(x.p, x.variant_id, 'Their'), buy: x.variant_id }); }).join('') + '</ul>'
          : '<p class="wally-saved__empty">These pieces aren’t available any more.</p><a class="wally-saved__button wally-saved__button--solid" href="/collections/new-in">Shop new in</a>');
    });
  }

  // Add a shared piece to the cart in their size. Pre-order and special-order sizes carry a note
  // (a line-item property) that only the product page renders, so read it from that page for this
  // size and send the same thing the product page's Add to cart would. Then tell the theme, which
  // updates the cart count and drawer (and opens the drawer if that's on).
  function addToCart(btn) {
    var variant = btn.getAttribute('data-variant');
    var handle = btn.getAttribute('data-handle');
    var fail = function () {
      btn.outerHTML = '<a class="wally-saved__buy wally-saved__choose" href="/products/' + esc(handle) + '?variant=' + esc(variant) + '">Open to add</a>';
    };
    btn.disabled = true;
    btn.textContent = 'Adding\u2026';
    fetch('/products/' + encodeURIComponent(handle) + '?variant=' + encodeURIComponent(variant))
      .then(function (r) { if (!r.ok) throw new Error('page'); return r.text(); })
      .then(function (html) {
        var form = new DOMParser().parseFromString(html, 'text/html').querySelector('form[data-type="add-to-cart-form"]');
        var props = {};
        if (form) {
          var inputs = form.querySelectorAll('input[name^="properties["]');
          for (var i = 0; i < inputs.length; i++) if (inputs[i].value) props[inputs[i].name.slice(11, -1)] = inputs[i].value;
        }
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variant), quantity: 1, properties: props }] }) });
      })
      .then(function (r) { if (!r.ok) throw new Error('add'); return fetch('/cart.js').then(function (c) { return c.json(); }); })
      .then(function (cart) {
        btn.outerHTML = '<a class="wally-saved__buy wally-saved__added" href="/cart">Added \u2713 View cart</a>';
        var ev = new Event('cart:update', { bubbles: true });
        ev.detail = { resource: cart, sourceId: 'wally-saved', data: { itemCount: cart.item_count, source: 'wally-saved', variantId: variant } };
        document.dispatchEvent(ev);
      })
      .catch(fail);
  }

  // The hint page is only for shared lists: on its own it is just the Saved page.
  if (page && page.getAttribute('data-handle') === 'hint' && !shared && !shareCode) {
    location.replace(cfg.page || '/pages/saved');
    page = null;
  }

  if (page) {
    page.addEventListener('click', function (e) {
      var t = e.target instanceof Element ? e.target : null;
      if (!t) return;
      var rm = t.closest('[data-remove]');
      var msg = page.querySelector('.wally-saved__msg');
      if (rm) {
        remove(String(rm.getAttribute('data-remove')));
        changed();
        renderPage();
      } else if (t.closest('.wally-saved__share')) {
        var url = shareUrl();
        if (navigator.share) {
          navigator.share({ title: SHARE_TITLE, text: SHARE_TEXT, url: url }).catch(function () { /* closed the sheet */ });
        } else {
          var show = function () { msg.textContent = 'Copy this link and send it on: ' + url; };
          if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { msg.textContent = 'Link copied. Send it to whoever\u2019s doing the shopping.'; }, show);
          else show();
        }
      } else if (t.closest('.wally-saved__add')) {
        addToCart(t.closest('.wally-saved__add'));
      }
    });
    renderPage();
  }

  refresh();
  var last = Number(sget(KEY.synced)) || 0;
  if (Date.now() - last > SYNC_EVERY_MS || removed.length) sync();
})();
